import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import {BootstrapVue , BootstrapVueIcons} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import ToggleButton from 'vue-js-toggle-button'
import LoadScript from 'vue-plugin-load-script';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import VueSignature from "vue-signature-pad";
import VueExcelXlsx from "vue-excel-xlsx";
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
import NoAutoComplete from 'vue-no-autocomplete'
import "leaflet/dist/leaflet.css";

Vue.use(NoAutoComplete)

Vue.use(VueFormWizard)
Vue.use(VueSignature)
Vue.use(LoadScript);

Vue.use(VueFeather)
Vue.use(flatPickr)

Vue.use(VueRouter)
Vue.use(vco)

Vue.use(ToggleButton)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(VueExcelXlsx);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(VueMask)


Vue.component('apexchart', VueApexCharts)
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

// Sentry.init({
//   Vue,
//   dsn: "https://fbad8bfecde945eb9c577e50ca7284ba@o930231.ingest.sentry.io/6196143",
//   integrations: [
//     new BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "my-site-url.com", /^\//],
//     }),
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });

const app = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

